// using js function return a React component as SVG
import { ReactComponent as ToastIcon } from '@/assets/svg/ToastIcon.svg';

export const ToastIconComponent = () => <ToastIcon />;
